<template>

    <div class="p-inputgroup" style="padding-top: 4px; position: relative;">

        <span v-if="icon" class="p-inputgroup-addon" style="cursor: default;">
          <i :class="icon"></i>
        </span>

        <div class="w-full">
            <span class="p-float-label">
                <Calendar :id="itc" ref="Calendar" v-model="curValue" :manualInput="false" :showButtonBar="true"
                          dateFormat="dd.mm.yy"
                          :hide-on-date-time-select="true" selectionMode="range"/>
                <label :for="itc" @click="labelClick">{{ label }}</label>
            </span>
        </div>

        <span v-show="showClearButton && curValue" style="position:absolute; right: 10px; top: 12px;">
            <a style="border:none; outline: none; position: relative;" @click="clearInput">
                <i class="pi pi-times" style="font-size: 0.7rem"></i>
            </a>
        </span>

    </div>


</template>

<script>
export default {
    name: "SearchDate",
    props: {
        modelValue: null,
        label: null,
        icon: {
            default: 'fa fa-fw fa-search',
            type: String,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            curValue: this.modelValue,
            itc: null,
        }
    },
    methods: {

        labelClick() {
            this.$refs.Calendar.$el.querySelector('input').focus();
        },

        clearInput() {
            this.curValue = undefined;
            this.$emit('update:modelValue', this.curValue);
        },
        generateIdTooInput() {
            this.itc = 'i_' + Math.random().toString(36).substring(2);
        }

    },
    watch: {
        curValue($new) {
            this.$emit('update:modelValue', $new);
        },
        modelValue($new) {
            this.curValue = $new;
        }
    },
    mounted() {
        this.generateIdTooInput();
    }

}
</script>

<style scoped>

</style>